import { OrganizationManager as e } from "../../organizationManager.js";
import { TokenManager as r } from "../../tokenManager.js";
const t = (t2) => {
  t2.interceptors.request.use(async (t3) => {
    const o = r.getState(), a = e.getState();
    return o && (t3.headers.Authorization = `Bearer ${o}`), a && (t3.headers.organizationId = a), t3;
  }, (e2) => Promise.reject(e2));
};
export {
  t as setupRequestInterceptor
};
//# sourceMappingURL=requestInterceptor.js.map
